import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { FictitiousMapModule } from '@blade-sxp/task-management/store/fictitiousMap';
import { debounce } from 'lodash';
let UEHotMapList = class UEHotMapList extends Vue {
    disabled;
    virtualAreaImg = require('@blade-sxp/task-management/assets/virtual-area.png');
    upper = require('@blade-sxp/task-management/assets/upper.png');
    below = require('@blade-sxp/task-management/assets/below.png');
    silderValue = 10;
    minValue = 0;
    maxValue = 10000;
    minlength = 1;
    debounceInput = debounce(this.silderValueChange, 800);
    get listPaintData() {
        return FictitiousMapModule.UEHotMapData;
    }
    get isData() {
        return FictitiousMapModule.UEHotMapData?.length > 0;
    }
    get getSilderValue() {
        return FictitiousMapModule.silderValue;
    }
    UEHotMapDataChange(val) {
        if (this.isData) {
            this.silderValue = val;
        }
    }
    startDraw() {
        const status = FictitiousMapModule.UEStatus;
        if (status) {
            FictitiousMapModule.updataUEStatus(false);
        }
        else {
            FictitiousMapModule.updataUEStatus(true);
        }
    }
    deleteRoi(id) {
        if (id) {
            FictitiousMapModule.clearUEHotMapData();
            FictitiousMapModule.updataSilderValue(10);
            this.silderValue = 10;
        }
    }
    silderValueChange(value) {
        this.silderValue = Number(value);
        FictitiousMapModule.updataSilderValue(this.silderValue);
    }
    changeValue(type) {
        if (type === 'UP' && this.silderValue < this.maxValue) {
            this.silderValue++;
        }
        if (type === 'DOWN' && this.silderValue > this.minValue) {
            this.silderValue--;
        }
    }
};
__decorate([
    Prop({ default: false, type: Boolean })
], UEHotMapList.prototype, "disabled", void 0);
__decorate([
    Watch('getSilderValue', { deep: true, immediate: true })
], UEHotMapList.prototype, "UEHotMapDataChange", null);
UEHotMapList = __decorate([
    Component({
        name: 'UEHotMapList',
        components: {},
        i18n: {
            messages: {
                zh: {
                    examples: '示例',
                    noData: '请在左侧地图内圈定虚拟区域范围',
                    virtualArea: '虚拟区域',
                    radius: '半径',
                    radiusTips: '辐射圆半径，取值范围：0~10000，单位：m',
                },
                en: {
                    examples: 'Example',
                    noData: 'please circle the virtual area on the map on the left',
                    virtualArea: 'Virtual Area',
                    radius: 'Radius',
                    radiusTips: 'Radius of the radiation circle, take the value range: 0 ~ 10000, unit: m',
                },
            },
        },
    })
], UEHotMapList);
export default UEHotMapList;
